import { usePointVideoHistoryReportCreateMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys, BaseMutationResultType } from '@shared/api/graphql/types';

export type PointVideoHistoryReportCreateResultType = {
  ok: boolean;
  downloadLink?: string | null;
};

export type UsePointBroadcastVideoHistoryReportCreateType = BaseMutationResultType & {
  request: (pointId: string, reportDate: string) => Promise<PointVideoHistoryReportCreateResultType>;
};

const usePointBroadcastVideoHistoryReportCreate = (): UsePointBroadcastVideoHistoryReportCreateType => {
  const [mutation, mutationResult] = usePointVideoHistoryReportCreateMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (pointId: string, reportDate: string) => {
    const mutationResult = await mutation({ variables: { input: { pointId, reportDate } } });
    return {
      ok: !!mutationResult.data?.pointPlaybackVideoReportCreateMutation?.ok,
      downloadLink: mutationResult.data?.pointPlaybackVideoReportCreateMutation?.downloadLink,
    };
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default usePointBroadcastVideoHistoryReportCreate;
